export const load = () => ({
	title: 'Soundproofing Windows NYC',
	showTitle: true,
});
